import { useQuery, useMutation } from "@tanstack/react-query";
import { transferVolunteerApiService } from "./transfervolunteer.api";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statusCode: number;
}

export const useTransferVolunteerService = ({
  searchText = "",
  currentPage = 1,
  pageSize = 10,
  enableSelectAll = false,
  volunteertransferid = null,
  studyid = null,
  volunteerid = null,
  isOutgoingOnly = false,
  getDropdown = false,
}: {
  searchText?: string;
  currentPage?: number;
  pageSize?: number;
  enableSelectAll?: boolean;
  volunteertransferid?: number | null;
  studyid?: number | null;
  volunteerid?: number | null;
  isOutgoingOnly?: boolean;
  getDropdown?: boolean;
} = {}) => {
  const SelectAllQuery = useQuery({
    queryKey: ["transfer-volunteer-select-all", searchText, currentPage, pageSize, studyid],
    queryFn: () =>
      transferVolunteerApiService.getSelectAllData({
        searchText,
        currentPage,
        pageSize,
        studyid: Number(studyid),
        isOutgoingOnly
      }),
    enabled: enableSelectAll && !!studyid,
  });

  const SelectQuery = useQuery({
    queryKey: ["transfer-volunteer-select", volunteertransferid],
    queryFn: () => transferVolunteerApiService.getSelectData(Number(volunteertransferid)),
    enabled: !!volunteertransferid,
  });

  const InsertMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => transferVolunteerApiService.insertData(payload),
  });

  const UpdateMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => transferVolunteerApiService.updateData(payload),
  });

  const VerifyMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => transferVolunteerApiService.verifyData(payload),
  });

  const DeleteMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => transferVolunteerApiService.deleteData(payload),
  });

  const StudyDropdownQuery = useQuery({
    queryKey: ["transfer-study-dropdown",studyid, volunteerid],
    queryFn: () =>
      transferVolunteerApiService.getStudyDropdownData({
        studyid: Number(studyid),
        volunteerid: Number(volunteerid),
      }),
    enabled: getDropdown,
  });

  return {
    SelectAllQuery,
    SelectQuery,
    InsertMutation,
    UpdateMutation,
    VerifyMutation,
    DeleteMutation,
    StudyDropdownQuery
  };
};
